import { useMutation } from '@tanstack/react-query';
import { documentWorkflowControllerBulkApplyDateMutation } from '@dealstack/shared/lib/backendClient/@tanstack/react-query.gen';
import type { BulkApplyDateDto } from '@dealstack/shared/lib/backendClient';
import { showToastV2 } from '@dealstack/frontend/shared/mechanism/toast/useToastV2';
import { getBackendErrorMessage } from '@dealstack/frontend/shared/dataExchange/ApiLayer/apiLayer';
import { useTranslationMipManage } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';
import type { UseBulkApplyDateArgs } from '@dealstack/frontend/app/pages/Project/MIP/hooks/useBulkApplyDate.types';

export const useBulkApplyDate = ({
	dealId,
	programmeId,
	onSuccess,
	onSettled,
}: UseBulkApplyDateArgs) => {
	const tMipManage = useTranslationMipManage();

	const mutation = useMutation({
		...documentWorkflowControllerBulkApplyDateMutation(),
		onSuccess,
		onError: (error) => {
			// Prefer the server's sentence: the error body carries no status or code, so its
			// message is the only thing identifying the actionable 409 (job already running).
			showToastV2({
				state: 'error',
				title:
					getBackendErrorMessage(error) ??
					tMipManage('documents_page.toast.apply_date.error'),
			});
		},
		onSettled,
	});

	return {
		mutate: (body: BulkApplyDateDto) =>
			mutation.mutate({ path: { dealId, programmeId }, body }),
		isPending: mutation.isPending,
	};
};
